import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { SkapaSimpleVideo, SkapaTokens } from '@inter-ikea-guida/skapa';
import { useCommonTranslation } from '../hooks/useCommonTranslation';
import { useGuidaUIStates } from '../hooks/useGuidaUIStates';
const StyledWrapper = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: ${props => (props.$isSidebarMode ? 'unset;' : '0.75/1')};
  max-height: ${props => (props.$isSidebarMode ? 'unset;' : '87vh')};
  border: 0;
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
  background: none;
`;
/** 101% width is to avoid a "border" in the video when it is scaled up */
const StyledSkapaSimpleVideo = styled(SkapaSimpleVideo) `
  width: 101%;
`;
const StyledHeadline = styled.h1 `
  position: absolute;
  top: ${SkapaTokens.space150};
  right: ${SkapaTokens.space200};
  z-index: 1;
  color: ${props => props.theme.framework.slideshow.headlineColor};
  font-size: ${SkapaTokens.fontSize500};
  font-weight: ${SkapaTokens.fontWeightBold};
  line-height: 1;
  margin: 0;

  text-align: end;

  @media (min-width: 500px) {
    top: ${SkapaTokens.space200};
    right: ${SkapaTokens.space250};
    font-size: ${SkapaTokens.fontSize700};
  }

  @media (min-width: ${SkapaTokens.breakpointL}) {
    top: ${SkapaTokens.space300};
    right: ${SkapaTokens.space400};
    font-size: ${SkapaTokens.fontSize1100};
  }
`;
export const GuidaSlideshowVideo = ({ title, src, coverImageSrc, altDescription }) => {
    const { t } = useCommonTranslation();
    const { isSidebarMode } = useGuidaUIStates();
    const prefersReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const shouldAutoPlay = !prefersReducedMotion && isSidebarMode;
    return (_jsxs(StyledWrapper, { "$isSidebarMode": isSidebarMode, "data-testid": 'slide-show', children: [_jsx(StyledHeadline, { children: title }), _jsx(StyledSkapaSimpleVideo, { src: src, poster: coverImageSrc, autoPlay: shouldAutoPlay, descriptionBody: altDescription, descriptionId: 'slideshow-description', playAriaLabel: t('VideoPlay'), pauseAriaLabel: t('VideoPause'), videoNotSupportedTxt: t('VideoNotSupported') })] }));
};
//# sourceMappingURL=GuidaSlideshowVideo.js.map